import React from "react"
import {Priority} from "../../../../../../gd/types/types";
import {FieldEditableProps} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";
import TaskTypeIcon from "../../../../../../gd-components/icons/task-icon/task-icon-ui5";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldTaskType_Editable"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldTaskType_Editable extends React.Component<FieldEditableProps, State> {

    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get canEdit():boolean {
        return !this.props.disabled && this.props.field.canEdit(this.props.model)
    }

    onMouseEnter = () => {

        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onValueChange(value:Priority, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        this.props.onChange && this.props.onChange(value)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    onOptionClick = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        this.onValueChange(option.value as Priority)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {

        const field = this.props.field
        const classes = Classes(this.classes, "is-hovered", {})

        // ui5-field-editable is-hovered w-100-percent h-100-percent

        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    {this.renderValue()}

                    {!this.props.iconOnly &&
                        <div className="buttons flex-no-shrink">
                            <div className="btn-arrow"/>
                        </div>
                    }

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.model} />
                    }

                </div>
            </React.Fragment>
        )
    }

    renderValue() {

        const taskType = gd.session.taskTypes.get(this.props.model.taskTypeId);

        if (this.props.iconOnly) {
            return (
                <div className={Classes("flex-row-center-center", "w-100-percent")}>
                    <TaskTypeIcon taskTypeId={this.props.model.taskTypeId}/>
                </div>
            )
        }

        return (
            <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>

                <TaskTypeIcon className="m-r-5 flex-row-center-center min-w-15 fl-no-shrink" taskTypeId={this.props.model.taskTypeId}/>
                <div className="max-w-100-percent txt-truncate cursor-default">{taskType?.name}</div>
            </div>
        )
    }

    renderNotHovered() {

        return (
            <React.Fragment>
                <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    {this.renderValue()}

                </div>
            </React.Fragment>
        )

    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)


        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()

    }

}



